import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    if (!sessionId) { nav("/login"); return; }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        localStorage.setItem("lwn_token", data.token);
        setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        nav("/dashboard", { state: { user: data.user } });
      } catch {
        nav("/login");
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen bg-[#1E3A2B] flex items-center justify-center">
      <p className="font-serif-d text-[#DCBB6C] text-2xl italic-emph animate-pulse">Stepping into the overflow…</p>
    </div>
  );
}
